import { useLocation, useNavigate, useParams, } from 'react-router-dom'
import AddMainPhotoModal from 'components/Modal/AddMainPhotoModal'
import DeleteBoardModal from 'components/Modal/DeleteBoardModal'
import LoginInfoModal from 'components/Modal/LoginInfoModal'
import EditDataModal from 'components/Modal/EditDataModal'
import AddGpsModal from 'components/Modal/AddGpsModal'
import ModalBuySomething from './ModalBuySomething'
import { useEffect, useState } from 'react'
import Skeleton from 'components/Skeleton'
import { openMap } from 'utils/openMap'
import Button from 'components/Button'
import TopBar from 'components/Topbar'
import useStore from 'hooks/useStore'
import { GET } from 'api/request'
import * as url from 'api/urls'

interface DateParts {
  day: string
  monthName: string
  year: string
}

type Modal = 'delete' | 'location' | 'editData' | 'addMainPhoto' | 'info' | 'login' | 'infoAndLogin'

const months = [
  'stycznia', 'lutego', 'marca', 'kwietnia', 'maja', 'czerwca',
  'lipca', 'sierpnia', 'września', 'października', 'listopada', 'grudnia'
]

const Profilepin: React.FC = () => {
  const { pathname, search } = useLocation()
  const [data, setData] = useState<board.BoardResponse | null>()
  const [isLoading, setLoading] = useState<boolean>(true)
  const [modal, setModal] = useState<Modal | ''>((() => {
    const queryParams = new URLSearchParams(search)
    const modalParam = queryParams.get('modal')
    return (modalParam === 'info' || modalParam === 'infoAndLogin')
      ? modalParam
      : ''
  })())

  const openStore = useStore()
  const navigate = useNavigate()
  const params = useParams()

  const fetchProfile = async () => {
    setLoading(true)
    const profileId = pathname.split('/profilepin/')[1]

    try {
      const response = await GET(`${url.boards}/${profileId}`)
      if (response.ok) {
        setData(response.data)
      } else if (response.status === 400 || response.status === 404) {
        navigate(`/unpublished/${profileId}`)
      } else {
        throw new Error('Failed to fetch profile')
      }
    } catch (err) {
      console.error(err)
    }
    setLoading(false)
  }

  const onReload = () => {
    fetchProfile()
  }

  useEffect(() => {
    fetchProfile()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname])

  const parseDate = (dateString: string): DateParts => {
    const [year, month, day] = dateString.split('-')
    const monthName = months[parseInt(month, 10) - 1]

    return {
      day,
      monthName,
      year
    }
  }

  const birthParts = data?.data?.birth ? parseDate(data.data.birth) : { day: '', monthName: '', year: '' }
  const deathParts = data?.data?.death ? parseDate(data.data.death) : { day: '', monthName: '', year: '' }

  const hideModal = () => {
    setModal('')
  }

  return (
    <>
      {modal === 'delete' && <DeleteBoardModal
        boardId={params['*']}
        onClose={hideModal}
        onReload={() => { navigate('/') }}
      />}
      {(modal === 'location' && data?.data?.id) && <AddGpsModal
        boardId={data.data.id}
        onClose={hideModal}
        reload={onReload}
      />}
      {modal === 'editData' && <EditDataModal
        shortVersion
        data={data}
        onClose={hideModal}
        onReload={onReload}
      />}
      {modal === 'addMainPhoto' && <AddMainPhotoModal
        body={data?.data}
        onClose={hideModal}
        onReload={onReload}
      />}
      {(modal === 'info' || modal === 'infoAndLogin') && <ModalBuySomething
        onClose={() => { setModal(modal === 'infoAndLogin' ? 'login' : '') }}
        body={data?.data}
      />}
      {modal === 'login' && <LoginInfoModal onClose={hideModal} />}

      <div className='profile'>
        {isLoading
          ? <Skeleton type='profile' />
          : <>
            <TopBar isSticky={false} theme='dark' title='Darmowy profil' />
            <div className="wrap">
              <div className="profile__image">
                <div className="imgWrap">
                  {data?.data.img !== null
                    ? <>
                      <img src={data?.data.img} alt="" />
                      <div className="iconEdit" onClick={() => setModal('addMainPhoto')}><i className="icon icon--edit"></i></div>
                    </>
                    : <p onClick={() => setModal('addMainPhoto')}>Brak zdjęcia, kliknij aby dodać</p>}
                </div>
              </div>

              <div className="wrapRight">
                <div className="profile__important">
                  <div className="profile__important__wrap">
                    <div className="profile__important__desc">
                      <div>
                        <span>{data?.data.years !== 0 ? 'Żył lat ' + data?.data.years : 'Żył ' + data?.data.days + " dni"}</span>
                      </div>
                      <h2>{data?.data.name}</h2>
                    </div>
                    <div className="profile__important__timeline">
                      <div className="top">
                        <span></span><hr /><span></span>
                      </div>
                      <div className="bottom">
                        <div>
                          <span>{birthParts.day} {birthParts.monthName}</span>
                          <span>{birthParts.year}</span>
                        </div>
                        <div>
                          <span>{deathParts.day} {deathParts.monthName}</span>
                          <span>{deathParts.year}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="profile__actions extra">
                  {data?.data.hasSavedLocation
                    ? <Button
                      type='round'
                      text='Nawiguj'
                      icon='navigate'
                      action={() => openMap(data?.data.gps.latitude, data?.data.gps.longitude)} />
                    : <Button
                      type='round'
                      text='Dodaj GPS'
                      icon='add-location'
                      action={() => setModal('location')} />}
                  <Button
                    type='round'
                    text='Edytuj'
                    icon='settings'
                    action={() => setModal('editData')} />
                  <Button
                    type='round'
                    text=''
                    icon='trash'
                    action={() => setModal('delete')} />
                </div>

                <div className="profilePin__content">
                  <div className="infobox">
                    <p>To bezpłatny profil, który pozwala stworzyć listę pomników
                      odwiedzanych 1 listopada.
                      Jeśli chcesz, aby Twoi bliscy mogli wspominać zmarłego
                      w wyjątkowy sposób, możesz zamówić
                      tabliczkę z kodem QR na jego pomnik.</p>
                  </div>
                  <div
                    className="button button--add"
                    onClick={() => {
                      if (!data?.data?.to_order) return
                      const { product_key, params } = data.data.to_order
                      openStore(product_key, { related: params.related, profileName: data.data.name })
                    }}>
                    <div className="arrowWrap">
                      <i className="icon icon--arrow-right"></i>
                    </div>
                    <h2>Kup tabliczkę QR na pomnik</h2>
                    <p>Stwórz profil zmarłego, aby Twoi bliscy mogli:</p>
                    <div className="element">
                      <div className="iconWrap">
                        <i className="icon icon--heart"></i>
                      </div>
                      <div className="content">
                        <h3>Wspomnieć zmarłego</h3>
                        <p>Obejrzeć jego profil, zdjęcia oraz filmy</p>
                      </div>
                    </div>
                    <div className="element">
                      <div className="iconWrap">
                        <i className="icon icon--candle"></i>
                      </div>
                      <div className="content">
                        <h3>Zapalić znicz</h3>
                        <p>Dowiesz się kto odwiedził pomnik</p>
                      </div>
                    </div>
                    <div className="element">
                      <div className="iconWrap">
                        <i className="icon icon--book"></i>
                      </div>
                      <div className="content">
                        <h3>Dodać wpis do księgi kondolencyjnej</h3>
                        <p>Bliscy dodadzą wpis, zdjęcia oraz filmy</p>
                      </div>
                    </div>
                    <div className="element">
                      <div className="iconWrap">
                        <i className="icon icon--add-location"></i>
                      </div>
                      <div className="content">
                        <h3>Zapiszą lokalizację</h3>
                        <p>Zapiszą pomnik do listy odwiedzanych 1 listopada</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>}

      </div>
    </>)
}

export default Profilepin